import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import { Box, Button } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { useHistory } from "react-router";
import AllBlogs from "@jumbo/Dashboards/News";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.newsPage"} />, isActive: "true" },
];

const News = () => {
  const history = useHistory();
  return (
    <PageContainer
      heading={<IntlMessages id="pages.newsPage" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent={"space-between"}
            alignItems={"center"}
            marginBottom={"10px"}
          >
            <div>
              <IntlMessages id="pages.newsPage.description" />
            </div>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Add />}
              onClick={() => history.push("/addNews")}
              style={{ marginRight: 14 }}
            >
              ساخت بلاگ
            </Button>
          </Box>

          <Divider />
          <div style={{ marginTop: 24 }}>
            <AllBlogs />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default News;
